import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../store';
import { selectIsSyncing, setIsModalOpen, setModalContent } from '../../../store/slices/global';
import { APP_ROUTES } from '../../../app.config.vars/routes';
import { abortGame } from '../../../api/game-mode/game';
import Headline from '../../../ui/Headline';
import Button from '../../../ui/Button';
import ButtonsGroup from '../../../ui/ButtonsGroup';
import Loader from '../../../ui/Loader';
const ConfirmAbortGame = () => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const isSyncing = useSelector(selectIsSyncing);
    const [isPending, setIsPending] = useState(false);
    const [errorKey, setErrorKey] = useState(null);
    const closeModal = () => {
        dispatch(setIsModalOpen(false));
        dispatch(setModalContent(null));
    };
    const handleConfirm = async () => {
        // answers still being uploaded could otherwise be stored after the session was deleted
        if (isSyncing) {
            setErrorKey('abort_game.sync_in_progress');
            return;
        }
        setIsPending(true);
        setErrorKey(null);
        const result = await abortGame();
        if (result === 'aborted') {
            closeModal();
            navigate(APP_ROUTES.rallies);
            return;
        }
        setIsPending(false);
        setErrorKey(result === 'no_internet' ? 'abort_game.no_internet' : 'abort_game.error');
    };
    return (_jsxs("div", { className: 'modal-content confirm-action', children: [_jsx("div", { className: "modal-content-title", children: _jsx(Headline, { title: t('abort_game.title'), type: 'h1' }) }), _jsx("p", { className: "modal-content-description", children: t('abort_game.text') }), errorKey && _jsx("p", { className: "form-field-error-message", children: t(errorKey) }), _jsx("div", { className: "modal-content-button", children: isPending ? (_jsx(Loader, {})) : (_jsxs(ButtonsGroup, { justify: 'center', children: [_jsx(Button, { label: t('abort_game.continue'), onClick: closeModal }), _jsx(Button, { variant: 'outlined', label: t('abort_game.confirm'), onClick: handleConfirm })] })) })] }));
};
export default ConfirmAbortGame;
